import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { PaperClip } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import CommomApproval from "../../../utils/CommomApproval";

function MOMIndex() {
  const ModelId = 18;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  const { statusValue } = useGetStatusData({ value: ModelId });
  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/minutes_of_meeting/`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/Minute-Of-Meeting/standard/${stdId}/status/${statusFilter}`
      : `/Minute-Of-Meeting/standard/${stdId}/`,
    page: pageIndex,
    pageCount: dataCount,
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);

  function clearFilter() {
    getData();
    navigate(".", { replace: true, state: { statusFilter: null } });
  }

  return (
    <>
      <ViewTableIndex
        label="CISO / MRM Meeting MoM"
        menu="Activity"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="activity_create"
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
      >
        <>
          {data &&
            data?.map((data, i) => (
              <div
                className=" w-full odd:bg-tableodd even:bg-tableeven shadow-box text-xs 2xl:text-sm py-0.5 px-3 flex justify-between  gap-x-3 my-2 "
                key={i}
              >
                <div className=" w-[14.5%] flex justify-start items-center pl-5 text-gray-500">
                  {data?.heading || "-"}
                </div>
                <div className=" w-[14.5%]">
                    <TempComp label="Group" value={data?.group_data || "-"} />
                    <TempComp
                      label="End Time"
                      value={data?.end_time != "None" ? data?.end_time : "-"}
                    />
                    <TempComp
                      label="Minutes By"
                      value={data?.minute_by || "-"}
                    />
                </div>
                <div className=" w-[14.5%]">
                    <TempComp 
                      label="Date" 
                      value={data?.mom_date != "None"? NuDateFormat({value: data?.mom_date,format: "DD-MMM-yyyy",}): "-"}
                    />
                    <TempComp
                      label="Regrets"
                      value={data?.regrets || "-"}
                    />
                    <TempComp
                      label="Status"
                      value={<span className={`rounded-md capitalize bg-primary text-[13px] text-white py-0.5 px-2`}>{data?.status}</span>  || "-"}
                    />
                </div>
                <div className=" w-[19.5%]">
                  <TempComp
                      label="Type of Meeting"
                      value={data?.type_of_meeting || "-"}
                    />
                  <TempComp
                      label="Venue"
                      value={data?.venue || "-"}
                    />
                </div>
                <div className=" w-[14.5%]">
                  <TempComp
                      label="Start Time"
                      value={data?.start_time != "None" ? data?.start_time : "-"}
                    />
                  <TempComp
                      label="Chaired By"
                      value={data?.chaired_by || "-"}
                    />
                </div>
                <div className=" w-[5%] flex justify-center items-center">
                  {data?.attachments?.length > 0 && <PaperClip />}
                </div>
                <div className=" w-[3%] flex justify-center items-center">
                  <ViewMore
                    data={data}
                    satusData={statusValue}
                    fetcher={getData}
                    getCompletion={getDashboardData}
                    id={stdId}
                  />
                </div>
              </div>
            ))}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyModal}
        onClose={handleOnClose}
        refreshData={getData}
        satusData={statusValue}
        getCompletion={getDashboardData}
        id={stdId}
      />
      <CommonXlsExport
        id={stdId}
        path={`mom`}
        name={`${standardDetailName} CISO / MRM Meeting MoM ${
          standardStartDate &&
          NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
        } ${standardEndDate && "to"} ${
          standardEndDate &&
          NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
        }`}
        visible={showExport}
        onClose={() => {
          setShowExport(false);
        }}
      />

      <CommonImport
        url={`/Minute-Of-Meeting/standard/${stdId}/import/`}
        refreshData={getData}
        getFuction={getDashboardData}
        visible={showImport}
        onClose={() => setShowImport(false)}
        hasRemoveApproval={true}
        moduleId={ModelId}
        standardId={stdId}
      />

      <CommomApproval
        visible={showApprovalModal}
        onClose={handleApprovalOnClose}
        refreshData={getData}
        moduleId={ModelId}
        id={stdId}
        moduleName="Master List Of Document"
        standardName={standardDetailName}
        getCompletion={getDashboardData}
      />
    </>
  );
}

export default MOMIndex;

const header = [];


function TempComp({label,value}){
  return (
    <tr>
    <td className=" py-1 font-medium text-xs 2xl:text-sm text-gray-900">{label}</td>
    <td className=" px-1 font-semibold text-gray-900">:</td>
    <td className=" py-1  text-xs 2xl:text-sm text-gray-500">{value || "-"}</td>
  </tr>
  )
}
